// extracted by mini-css-extract-plugin
export default {"container":"style__container--V6wrW","card":"style__card--XYP0T","divider":"style__divider--F1MA0"};